module.exports = __webpack_public_path__ + "static/media/hockey-video.41631ca7.m4v";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/hockey-video.m4v
// module id = 201
// module chunks = 0